import { ActionSheet } from '@shared/components/ActionSheet';
import { View } from '@shared/components/View';
import { NativeDropdownButton } from '@shared/components/dropdown';
import { MBIconV2 } from '@shared/components/image';
import { MBTouchableOpacity } from '@shared/components/touchable';
import { MBTextBody1Bold } from '@shared/components/typography';
import { Batch } from '@shared/scenes/cards/entityBulkActions/BatchCreateContext/BatchContext';
import { Colors, grid } from '@shared/styles';
import { useBoolean } from '@shared/util/hooks';
import { i18n } from '@shared/util/i18n';
import { useMonthOptions } from './hooks/useMonthOptions';

export function MonthOptionsMobile({
  rruleOptions,
  setRruleOptions,
}: Pick<Batch, 'rruleOptions' | 'setRruleOptions'>) {
  const [showDateSelectMenu, openDateSelectMenu, closeDateSelectMenu] = useBoolean();
  const [showNthSelectMenu, openNthSelectMenu, closeNthSelectMenu] = useBoolean();
  const [showDaySelectMenu, openDaySelectMenu, closeDaySelectMenu] = useBoolean();

  const dateAnchorName = '--month-options-date-select';
  const nthAnchorName = '--month-options-nth-select';
  const dayAnchorName = '--month-options-day-select';

  const {
    dateSelectOptions,
    nthSelectOptions,
    daySelectOptions,
    handleDayOfMonthSelect,
    handleFullNthSelect,
    isDayOfMonthSelected,
    isNthWeekdaySelected,
    dayOfMonthDisplay,
    nthDayDisplay,
    nthDayWeekdayDisplay,
  } = useMonthOptions({ rruleOptions, setRruleOptions });

  return (
    <View>
      <MBTextBody1Bold>
        {i18n('workflowTemplate.component.dateAndRepeat.onDotDotDot')}
      </MBTextBody1Bold>
      <View
        row
        centerVertically
        paddingTop={1}
        paddingBottom={1}
        style={{
          flexShrink: 1,
          flexGrow: 0,
          width: '100%',
        }}
      >
        <MBTouchableOpacity
          style={{ display: 'flex', marginRight: grid(0.5), flexShrink: 0, flexGrow: 0 }}
          onPress={handleDayOfMonthSelect}
        >
          {isDayOfMonthSelected && (
            <MBIconV2 color={Colors.v2.green} name="radio-button" size={grid(5)} />
          )}

          {!isDayOfMonthSelected && (
            <MBIconV2 color={Colors.v2.green} name="unfilled-circle" size={grid(5)} />
          )}
        </MBTouchableOpacity>
        <View style={{ anchorName: dateAnchorName }}>
          <NativeDropdownButton onPress={openDateSelectMenu} disabled={!showDateSelectMenu}>
            {dayOfMonthDisplay}
          </NativeDropdownButton>
        </View>
        {showDateSelectMenu && (
          <ActionSheet
            anchorName={dateAnchorName}
            onClose={closeDateSelectMenu}
            options={dateSelectOptions}
          />
        )}
      </View>
      <View
        row
        centerVertically
        paddingTop={1}
        paddingBottom={1}
        style={{
          flexShrink: 1,
          flexGrow: 0,
          width: '100%',
        }}
      >
        <MBTouchableOpacity
          style={{ display: 'flex', marginRight: grid(0.5), flexShrink: 0, flexGrow: 0 }}
          onPress={handleFullNthSelect}
        >
          {isNthWeekdaySelected && (
            <MBIconV2 color={Colors.v2.green} name="radio-button" size={grid(5)} />
          )}

          {!isNthWeekdaySelected && (
            <MBIconV2 color={Colors.v2.green} name="unfilled-circle" size={grid(5)} />
          )}
        </MBTouchableOpacity>
        <View style={{ anchorName: nthAnchorName }}>
          <NativeDropdownButton
            onPress={openNthSelectMenu}
            disabled={!showNthSelectMenu}
            style={{ flexGrow: 0, flexShrink: 1 }}
          >
            {nthDayDisplay}
          </NativeDropdownButton>
        </View>
        {showNthSelectMenu && (
          <ActionSheet
            anchorName={nthAnchorName}
            onClose={closeNthSelectMenu}
            options={nthSelectOptions}
          />
        )}
        <View style={{ anchorName: dayAnchorName }}>
          <NativeDropdownButton onPress={openDaySelectMenu} disabled={!showDaySelectMenu}>
            {nthDayWeekdayDisplay}
          </NativeDropdownButton>
        </View>
        {showDaySelectMenu && (
          <ActionSheet
            anchorName={dayAnchorName}
            onClose={closeDaySelectMenu}
            options={daySelectOptions}
          />
        )}
      </View>
    </View>
  );
}
